export const ETAPA_RECEBIDOS = 'recebidos'
export const ETAPA_SELECIONADOS = 'selecionados'
export const ETAPA_CONTRATADO = 'contratado'

export const ETAPAS_FUNIL = [
  { id: ETAPA_RECEBIDOS, label: 'Recebidos' },
  { id: ETAPA_SELECIONADOS, label: 'Selecionados' },
  { id: ETAPA_CONTRATADO, label: 'Contratado' },
]

export const CONTRFORN_STATUS_ATIVO_FALLBACK_ID = 2

export const resolveAtivoStatusIds = (statusRows = []) => {
  const fromNome = (Array.isArray(statusRows) ? statusRows : [])
    .filter((row) => String(row.contrFornStatus_nome || '').trim().toLowerCase() === 'ativo')
    .map((row) => Number(row.contrFornStatus_id))
    .filter((id) => id > 0)

  if (fromNome.length > 0) return new Set(fromNome)
  return new Set([CONTRFORN_STATUS_ATIVO_FALLBACK_ID])
}

export const classifyCandidatoEtapa = (candidato, ativoStatusIds) => {
  const contrFornId = Number(candidato?.contrForn_id) || 0
  if (!contrFornId) return ETAPA_RECEBIDOS

  const statusId = Number(candidato?.contrFornStatus_id) || 0
  if (ativoStatusIds.has(statusId)) return ETAPA_CONTRATADO
  return ETAPA_SELECIONADOS
}

export const matchesVagaFilter = (vaga, rawFilter) => {
  const filter = String(rawFilter || '').trim().toLowerCase()
  if (!filter) return true

  const haystack = [
    vaga.vaga_id,
    vaga.vaga_cargo,
    vaga.vaga_nome,
    vaga.vaga_descricao,
    vaga.pedidoCompra_desc,
    vaga.proj_nome,
    vaga.contrato_label,
    vaga.pf_nomeExibicao,
  ]
    .map((value) => String(value || '').toLowerCase())
    .join(' ')

  return haystack.includes(filter)
}

export const formatContratoLabel = (vaga) => {
  const contrFornId = Number(vaga?.contrForn_id) || 0
  if (contrFornId) {
    return vaga.contrForn_num
      || vaga.contrForn_desc
      || `#${contrFornId}`
  }

  const contratoInternoId = Number(vaga?.contratoForn_id) || 0
  if (contratoInternoId) {
    const internoNome = vaga.contratoForn_desc || `#${contratoInternoId}`
    return `${internoNome} (interno)`
  }

  return null
}

export const parseInhireCandidateCount = (payload) => {
  if (payload == null) return null
  if (typeof payload.total === 'number') return payload.total
  if (typeof payload.totalCount === 'number') return payload.totalCount
  if (typeof payload.count === 'number') return payload.count
  if (typeof payload.pagination?.total === 'number') return payload.pagination.total

  const list = payload.jobTalents || payload.items || payload.data || payload
  if (Array.isArray(list)) return list.length
  return null
}

export const countEtapas = (candidatos, ativoStatusIds) => (
  (candidatos || []).reduce((acc, candidato) => {
    const etapa = classifyCandidatoEtapa(candidato, ativoStatusIds)
    acc[etapa] += 1
    return acc
  }, {
    [ETAPA_RECEBIDOS]: 0,
    [ETAPA_SELECIONADOS]: 0,
    [ETAPA_CONTRATADO]: 0,
  })
)
